import React, { useEffect, useState } from 'react';
import { Loader, PublicationOptionForm } from 'components';
import { useApp, useDeposit } from 'providers';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routes';
import { TRACKING_PAGES, UserManagementService } from 'api';
import { User } from 'types';
import { usePageTracking } from 'hooks';

export const PublicationOptionsPage: React.FC = () => {
  const { user } = useApp();
  const history = useHistory();
  const { price } = useDeposit();
  const [userData, setUserData] = useState<User>();
  const [loading, setLoading] = useState(true);

  if (!price) {
    history.replace(ROUTES.vehiclePrice);
  }

  usePageTracking(TRACKING_PAGES.OPTIONS_PART);

  useEffect(() => {
    UserManagementService.getUser(user!.id)
      .then(setUserData)
      .finally(() => setLoading(false));
  }, [user]);

  return loading ? <Loader /> : <PublicationOptionForm user={userData!} />;
};
